import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: ['edit'],
  teamId: '',
  companyCode: '',
  isChairman: '',
  isLeader: '',
  id:0,
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  // SET_NAME: (state, name) => {
  //   state.name = name
  // },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  // SET_ROLES: (state, roles) => {
  //   state.roles = roles
  // },
  updateId (state, id) {
    state.id = id
  },
  updateName (state, name) {
    state.name = name
  },
  updateTeamId (state, teamId) {
    state.teamId = teamId
  },
  updateCompanyCode (state, companyCode) {
    state.companyCode = companyCode
  },
  updateIsChairman (state, isChairman) {
    state.isChairman = isChairman
  },
  updateIsLeader (state, isLeader) {
    state.isLeader = isLeader
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    console.log(process.env)
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({  username: username,
      password: password,
      companyCode: process.env.VUE_APP_COMPANY_CODE,}).then(response => {
        const { token } = response
        commit('SET_TOKEN', token)
        setToken(token)
        // this.$cookie.set('token',token)
        getInfo().then(res =>{
          console.log('2')
          sessionStorage.setItem("companyCode",res.user.companyCode);
          sessionStorage.setItem("isChairman",res.user.isChairman);
          sessionStorage.setItem("isLeader",res.user.isLeader);
          
        })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response
        // if (!data) {
        //   reject('Verification failed, please Login again.')
        // }
        const {  username, userId, teamId, companyCode, isChairman, isLeader } = data.user
        // roles must be a non-empty array
        // if (!roles || roles.length <= 0) {
        //   reject('getInfo: roles must be a non-null array!')
        // }
        // commit('SET_ROLES', ["admin"])
        commit('SET_NAME', username)
        commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
        commit('SET_INTRODUCTION', 'I am a super administrator')
        commit('updateId', userId)
        commit('updateName', username)
        commit('userTeamId', teamId)
        commit('userCompanyCode', companyCode)
        commit('isChairman', isChairman)
        commit('isLeader', isLeader)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()
        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
